import { useAppSelector } from "app/hooks";

import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Tooltip } from "@mui/material";

import { useConfirm } from "material-ui-confirm";

import { unwrappableActionSnackbarNotificationDecorator } from "utils/unwrappableActionSnackbarNotificationDecorator";
import { useStartDossierExportMutation } from "services/streamingApi/caseManager.api";
import { caseViewerSelectors } from "./store/selectors";

export function DossierExportButton() {
    const dossier = useAppSelector(caseViewerSelectors.selectDossier);

    const [
        startDossierExport,
        { isLoading: isLoadingStartDossierExportMutation },
    ] = useStartDossierExportMutation();

    const confirm = useConfirm();

    return (
        <>
            {dossier && (
                <Tooltip title="Trigger dossier export">
                    <LoadingButton
                        sx={{ color: "white" }}
                        variant="text"
                        loadingPosition="center"
                        loading={isLoadingStartDossierExportMutation}
                        onClick={() => {
                            confirm({
                                description: `Are you sure you want to trigger a new export job for the current dossier?`,
                                confirmationText: "Yes",
                                cancellationText: "No",
                            }).then((confirmResult) => {
                                if (confirmResult.confirmed) {
                                    unwrappableActionSnackbarNotificationDecorator(
                                        startDossierExport({
                                            dossierId: dossier.id,
                                        }),
                                        `Export job started, you will be notified when its ready`,
                                        `Failed to start export job for the current dossier, please try again`,
                                        undefined,
                                        "info",
                                    );
                                }
                            });
                        }}
                    >
                        <Download />
                    </LoadingButton>
                </Tooltip>
            )}
        </>
    );
}
